import { useRef, useEffect, useState } from 'react';

export const useInterval = (callback, delay) => {
  const savedCallback = useRef();
  const [id, setId] = useState();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };

    if (delay !== null) {
      const newId = setInterval(tick, delay);
      setId(newId);

      return () => clearInterval(newId);
    }
  }, [delay]);

  return () => clearInterval(id);
};
